import { render, staticRenderFns } from "./TutorialArticleForm.vue?vue&type=template&id=1600d886&scoped=true"
import script from "./TutorialArticleForm.vue?vue&type=script&lang=js"
export * from "./TutorialArticleForm.vue?vue&type=script&lang=js"
import style0 from "./TutorialArticleForm.vue?vue&type=style&index=0&id=1600d886&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1600d886",
  null
  
)

export default component.exports